import { domainService } from './domain.service'

export default {
  domain: domainService
}
